import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { Link, withRouter } from 'react-router-dom';
import { Button, Icon } from 'antd';
import styled from 'styled-components';
import ExternalLink from '../ExternalLink';
import Logo from '../../assets/images/clear-h2o-logo-white.svg';
import theme from "../../theme";


const StyledHeader = styled.header`
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 2;
    background: ${props => props.theme.palette.black};
    padding: ${props => props.theme.unit * 3}px;
    
    .button-wrapper i {
        color: white;
        font-size: 18px;
    }
    
    & img {
        width: ${props => props.theme.unit * 22.5}px;
    }
    
    & button:first-child {
        margin-right: ${props => props.theme.unit}px;
    }
    
    @media (max-width: ${props => props.theme.breakpoint.sm}px) {
        align-items: center;
        justify-content: space-between;
        padding: ${props => props.theme.unit * 2}px;
        
        & img {
            width: ${props => props.theme.unit * 20}px;
        }
        
        & .btn-mobile {
            margin-right: 0 !important;
        }
    }
`;

const Header = ({ location }) => {
    const isSmDown = useMediaQuery({
        maxWidth: theme.breakpoint.sm,
    });

    const handleRefresh = () => {
        if (location.pathname === '/') {
            window.location.reload();
        }
    };

    return (
        <StyledHeader>
            <Link to="/" onClick={handleRefresh}>
                <img src={Logo} alt="Clear H2O Window Cleaning Ltd" />
            </Link>
            <div className="button-wrapper">
                {
                    isSmDown
                    ? <Icon type="menu" />
                    : <>
                        <Button className="btn-desktop" type="primary">
                            <Link to="/" onClick={handleRefresh}>
                                Make a booking
                            </Link>
                        </Button>
                        <Button className="btn-desktop" type="link">
                            <ExternalLink urlKey="MY_WEBSITE" style={{ color: 'white' }}>
                                Visit our website
                            </ExternalLink>
                        </Button>
                    </>
                }
            </div>
        </StyledHeader>
    );
};

export default withRouter(Header);
